import { render, staticRenderFns } from "./TodasSims.vue?vue&type=template&id=5a41074b&"
import script from "./TodasSims.vue?vue&type=script&lang=ts&"
export * from "./TodasSims.vue?vue&type=script&lang=ts&"
import style0 from "./TodasSims.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5a41074b', component.options)
    } else {
      api.reload('5a41074b', component.options)
    }
    module.hot.accept("./TodasSims.vue?vue&type=template&id=5a41074b&", function () {
      api.rerender('5a41074b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/SolicitudBajaSim/Crear/TodasSims.vue"
export default component.exports